import { Href } from "../../Constants/Constants";
import { Route } from "../../Routers/RouteList";

export const SocialGroupData = [
  { class: "google", url: "https://www.facebook.com/", icon: "facebook" },
  { class: "twiter", url: "https://twitter.com/", icon: "twitter" },
  { class: "linkedin", url: "https://in.linkedin.com/", icon: "linkedin" },
  { class: "instagram", url: "https://www.instagram.com/", icon: "instagram" },
];

export const FooterData = [
  {
    title: "Useful Links",
    links: [
      {
        text: "Home",
        url: Route.Messenger,
      },
      {
        text: "About us",
        url: Route.About,
      },
      {
        text: "Services",
        url: Route.About,
      },
      {
        text: "Blog",
        url: Route.RightSidebar,
      },
      {
        text: "Contact",
        url: Route.Login,
      },
    ],
  },
  {
    title: "chatzy Help",
    links: [
      {
        text: "Privacy Policy",
        url: Route.About,
      },
      {
        text: "FAQ",
        url: Route.Faq
      },
      {
        text: "Support",
        url: Route.About,
      },
      {
        text: "Contact",
        url: Route.Login,
      },
      {
        text: "Tearm",
        url: Route.About,
      },
    ],
  },
  {
    title: "Download For",
    links: [
      {
        text: "Windows",
        url: Href,
      },
      {
        text: "Linux",
        url: Href,
      },
      {
        text: "IOS",
        url: Href,
      },
      {
        text: "Android",
        url: Href,
      },
      {
        text: "Mac",
        url: Href,
      },
    ],
  }
];
